// Action Types
export const VM_SET_USER = "VM_SET_USER";
export const VM_SET_AUTH = "VM_SET_AUTH";
export const VM_RESET_USER = "VM_RESET_USER";
export const VM_SET_USER_DETAILS = "VM_SET_USER_DETAILS";
export const VM_SET_USER_DOMAINS = "VM_SET_USER_DOMAINS";
export const VM_SET_USER_SUB_DOMAINS = "VM_SET_USER_SUB_DOMAINS";

// Fetch Action Types
export const VM_FETCH_USER_DETAILS = "VM_FETCH_USER_DETAILS";
export const VM_FETCH_USER_DOMAINS = "VM_FETCH_USER_DOMAINS";
export const VM_FETCH_USER_SUB_DOMAINS = "VM_FETCH_USER_SUB_DOMAINS";
export const VM_UPLOAD_USER_LOGO = "VM_UPLOAD_USER_LOGO";
export const VM_DELETE_USER_LOGO = "VM_DELETE_USER_LOGO";
export const VM_UPDATE_VENDOR_EXPERIENCE = "VM_UPDATE_VENDOR_EXPERIENCE";

// Action Creators
export const setUser = (user = {}) => ({ type: VM_SET_USER, payload: user });
export const setAuth = (isAuth = false) => ({
  type: VM_SET_AUTH,
  payload: isAuth,
});

export const uploadUserLogo = (file, cb = () => {}) => ({
  type: VM_UPLOAD_USER_LOGO,
  file,
  cb,
});

export const deleteUserLogo = (cb = () => {}) => ({
  type: VM_DELETE_USER_LOGO,
  cb,
});

export const updateVendorExperience = (vendorId, payload, cb = () => {}) => ({
  type: VM_UPDATE_VENDOR_EXPERIENCE,
  vendorId,
  payload,
  cb,
});

export const resetUser = () => ({ type: VM_RESET_USER });
export const setUserDetails = (userDetails = {}) => ({
  type: VM_SET_USER_DETAILS,
  payload: userDetails,
});
export const setUserDomains = (domains = []) => ({
  type: VM_SET_USER_DOMAINS,
  payload: domains,
});
export const setUserSubDomains = (subDomains = []) => ({
  type: VM_SET_USER_SUB_DOMAINS,
  payload: subDomains,
});

// Fetch Action Creators
export const fetchUserDetails = (userId) => ({
  type: VM_FETCH_USER_DETAILS,
  userId,
});
export const fetchUserDomains = (userId) => ({
  type: VM_FETCH_USER_DOMAINS,
  userId,
});
export const fetchUserSubDomains = (userId) => ({
  type: VM_FETCH_USER_SUB_DOMAINS,
  userId,
});
